<div
  role="dialog"
  aria-labelledby="modalAddEditContactTitle"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="modalAddEditContactTitle">{{ 'kanban.productQuickForm.createProduct' | translate }}</h5>
        <button
          type="button"
          class="btn-close"
          aria-label="Close"
          (click)="close()"
        ></button>
      </div>

      <div class="modal-body">
        <form [formGroup]="formGroup">
          <div class="row">
            <div class="col-12 mb-3">
              <label class="form-label">
                {{ 'kanban.productQuickForm.name' | translate }}
                <span class="text-danger">*</span>
              </label>
              <input
                type="text"
                class="form-control"
                formControlName="name"
                [placeholder]="'kanban.productQuickForm.namePlaceholder' | translate"
              />
              <field-error-component
                [field]="'name'"
                [label]="'kanban.productQuickForm.name' | translate"
                [formGroup]="formGroup"
              />
            </div>
          </div>

          <div class="row">
            <div class="col-12 mb-3">
              <label class="form-label">
                {{ 'kanban.productQuickForm.price' | translate }}
                <span class="text-danger">*</span>
              </label>
              <input
                type="text"
                class="form-control"
                formControlName="price"
                placeholder="R$ 0,00"
                mask="separator.2"
                thousandSeparator="."
                decimalMarker=","
                prefix="R$ "
                [typeFromDecimals]="true"
                [leadZero]="true"
                [outputTransformFn]="moneyMaskOutput"
              />
              <field-error-component
                [field]="'price'"
                [label]="'kanban.productQuickForm.price' | translate"
                [formGroup]="formGroup"
              />
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-light" (click)="close()">
          {{ 'kanban.productQuickForm.close' | translate }}
        </button>
        <button type="button" class="btn btn-primary" (click)="save()">
          {{ 'kanban.productQuickForm.save' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
